<div class="popular-bets-bet-builder-pod-header">
    <ng-template #badgeContainer></ng-template>
    @if (hasLogo()) {
        <div class="popular-bets-bet-builder-pod-header__event-participants-wrapper">
            <ms-participant-image
                class="popular-bets-bet-builder-participant-image"
                [participantImage]="event().participants[0]?.image"
                [sportId]="event().sport.id"
                [showLogoColor]="true" />
            <div class="popular-bets-bet-builder-pod-header__event-participants-seperator" [style.color]="titleColor()">
                {{ logoSeparatorText }}
            </div>
            <ms-participant-image
                class="popular-bets-bet-builder-participant-image"
                [participantImage]="event().participants[1]?.image"
                [sportId]="event().sport.id"
                [showLogoColor]="true" />
        </div>
    } @else {
        <div class="popular-bets-bet-builder-pod-header__event-name" [style.color]="titleColor()">
            {{ eventTitle }}
        </div>
    }
</div>
<div class="popular-bets-bet-builder-pod-header__event-date">
    @if (event().startDate) {
        <ms-event-timer class="popular-bets-pod__header__date" [start]="event().startDate" [isDynamicTimer]="false" [style.color]="titleColor()" />
    }
</div>
